// This is needed to prevent having to add domains of any image the site pulls in to next.config.js
const imageLoader = ({ src }: any) => src

export default imageLoader
